import React, { useState } from "react";
import axios from "axios";
import "./Admin.css";
 import { useNavigate } from "react-router-dom";

function Admin() {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);
 
 const navigate = useNavigate();
  // رفع الصورة على السيرفر المحلي
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      setUploading(true);
      const res = await axios.post("https://api.kafkaorostkaffee.com/upload", formData);
      setImageUrl(res.data.imageUrl); // رابط الصورة بعد الرفع
    } catch (err) {
      console.error("Error uploading image:", err);
      alert("Failed to upload image!");
    } finally {
      setUploading(false);
    }
  };

  // إضافة Dish
 const addDish = async () => {
  if (!title || !price || !category || !description || !imageUrl) {
    alert("Please fill all fields!");
    return;
  }

  try {
    const token = localStorage.getItem("token"); // جلب التوكن بعد login
    await axios.post(
      "https://api.kafkaorostkaffee.com/add-dish",
      {
        title,
        price,
        category,
        description,
        image_url: imageUrl,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // إرسال التوكن
        },
      }
    );
    alert("Dish Added ✅");

    setTitle("");
    setPrice("");
    setCategory("");
    setDescription("");
    setImageUrl("");

    navigate("/admindash"); // تحويل بعد الإضافة
  } catch (err) {
    console.error("Error adding dish:", err);
    alert(err.response?.data?.error || "Failed to add dish");
  }
};

  return (
    <div className="admin-container">
      <h1>Add New Dish</h1>
      <div className="admin-form">
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          type="number"
          placeholder="Price"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="">Select Category</option>
          <option value="breakfast">Breakfast</option>
          <option value="hotdrinks">Hot Drinks</option>
          <option value="milkshakes">MilkShakes</option>
          <option value="frappe">frappe</option>
          <option value="tea">tea</option>
           <option value="tarte">tarte</option>
            <option value="bubbletea">Bubble tea</option>
             <option value="cookies"> cookies</option>
             <option value="salads"> salads</option>
          <option value="smoothie">smoothie</option>
          <option value="icedlatte">IcedLatte</option>
          <option value="dessert">dessert</option>
          <option value="refresher">refresher</option>
          
      
        </select>
        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        {/* رفع الصورة */}
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {uploading && <p>Uploading image...</p>}
        {imageUrl && (
          <div>
            <img src={`https://api.kafkaorostkaffee.com${imageUrl}`} alt="preview" width="150" />
          </div>
        )}

        <button onClick={addDish} disabled={uploading}>
          {uploading ? "Uploading..." : "Add Dish"}
        </button>
      </div>
    </div>
  );
}

export default Admin;
